import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    template: `
        <div mat-dialog-title *ngIf="!isUnpaid">Trial Expired</div>
        <div mat-dialog-title *ngIf="isUnpaid">Workspace Disabled</div>
        <div *ngIf="!isUnpaid" mat-dialog-content>
            <p>The trial period for your Attensa workspace has expired.</p>   
            <p>We hope that you will continue with Attensa and we are standing ready to help in any way we can.</p>  
            <p>Please contact your workspace administrator about using Attensa going forward.</p>  
            <p>If you have any questions your can contact us at support@attensa.com.</p>
            <p>Thanks,</p>
            <p>The Team at Attensa</p>
        </div>
        <div *ngIf="isUnpaid" mat-dialog-content>
            <p>Your Attensa workspace has been disabled.</p>   
            <p>We hope that you will continue with Attensa and we are standing ready to help in any way we can.</p>  
            <p>Please contact your workspace administrator about using Attensa going forward.</p>
            <p>If you have any questions your can contact us at support@attensa.com.</p>
            <p>Thanks,</p>
            <p>The Team at Attensa</p>
        </div>
    `
})
export class TenantSuspendedDialogComponent {

    constructor(@Inject(MAT_DIALOG_DATA) public isUnpaid: boolean) {}
}